import { render } from "./ElectionVoteSection.vue?vue&type=template&id=4663692c&scoped=true"
import script from "./ElectionVoteSection.vue?vue&type=script&lang=js"
export * from "./ElectionVoteSection.vue?vue&type=script&lang=js"

import "./ElectionVoteSection.vue?vue&type=style&index=0&id=4663692c&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4663692c"]])

export default __exports__